import type { SVGProps } from "react";
export interface MoneyBillDollarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MoneyBillDollarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MoneyBillDollarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 8c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v8c0 1.035.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.876zm2.25 8A4.125 4.125 0 0 1 19 20.124H5a4.125 4.125 0 0 1-4.125-4.126V8A4.125 4.125 0 0 1 5 3.875h14A4.125 4.125 0 0 1 23.125 8z"
      />
      <path
        fill={color}
        d="M4.375 12.5v-1a1.125 1.125 0 0 1 2.25 0v1a1.125 1.125 0 0 1-2.25 0m13 0v-1a1.125 1.125 0 0 1 2.25 0v1a1.125 1.125 0 0 1-2.25 0m-6.079-2.215a.2.2 0 0 0 .006.05h.002l.001.003a.4.4 0 0 0 .062.056c.133.097.4.21.854.3 1.237.247 2.732 1.106 2.732 2.83 0 1.23-.781 2.224-1.842 2.64a1.123 1.123 0 0 1-2.22.024 2.9 2.9 0 0 1-1.714-1.608l-.072-.193-.03-.112a1.124 1.124 0 0 1 2.123-.706l.041.107.032.075c.04.076.1.154.185.218.104.078.273.155.545.155.453 0 .701-.324.702-.6 0-.096-.029-.182-.148-.289a1.4 1.4 0 0 0-.514-.268l-.261-.067c-.563-.113-1.211-.304-1.737-.687-.584-.425-.997-1.076-.997-1.937q0-.053.006-.105v-.003h.002c.046-1.16.851-1.984 1.835-2.342a1.125 1.125 0 0 1 2.218-.013 2.9 2.9 0 0 1 1.789 1.8 1.126 1.126 0 0 1-2.135.712.63.63 0 0 0-.217-.295c-.103-.078-.271-.155-.543-.155a.9.9 0 0 0-.574.185c-.113.094-.129.174-.13.213v.012Z"
      />
    </svg>
  );
}
